<template>
  <div class="text-left bg-nw-ash2 h-screen px-4">
    <div class="mt-11 inline-block" @click="close">
      <back-arrow-icon :width="'w-4'"></back-arrow-icon>
    </div>
    <div class="pt-10">
      <div class="bg-white rounded-t-3xl p-6">
        <div class="flex items-center justify-between">
          <div class="w-full">
            <div class="inline-block absolute">
              <profile-icon :width="'w-14'" :height="'h-14'"></profile-icon>
            </div>
            <div class="inline-block text-black leading-3 pl-16 pt-2">
              <div class="text-sm font-extrabold pl-2">
                {{ user_details ? user_details.first_name + ' ' + user_details.last_name : '' }}
              </div>
              <span class="text-xxs pl-2">{{
                user_details ? user_details.first_name.split('')[0] + '. ' + user_details.last_name.split('')[0] : ''
              }}</span>
            </div>
          </div>
          <div class="text-right inline-block" @click="edit_profile = true">
            <edit-icon></edit-icon>
          </div>
        </div>
        <!-- <div class="pt-6 pl-5">
          <div class="text-sm text-black font-extrabold">Your Referral Code</div>
          <div class="text-xs inline-block">2x3cyt485</div>
          <div class="inline-block ml-14"><copy-icon></copy-icon></div>
        </div> -->
      </div>
    </div>
    <div class="pt-3">
      <div class="bg-white rounded-b-3xl p-6">
        <div class="w-full">
          <div class="inline-block"><phone-icon></phone-icon></div>
          <div class="text-sm inline-block pl-4">
            {{ user.phoneNumber ? user.phoneNumber : '' }}
          </div>
          <div class="text-xxs float-right mt-1 text-nw-ash inline-block">Mobile</div>
        </div>
        <div class="border-b border-gray-100 pt-6 ml-8 -mr-6"></div>
        <div class="w-full pt-6 flex xxs:block items-center justify-between">
          <div class="inline-block"><email-icon></email-icon></div>
          <div class="text-sm inline-block pl-4 pr-2">
            {{ user_details ? user_details.email : '' }}
          </div>
          <div class="text-xxs float-right mt-1 text-nw-ash inline-block">Email</div>
        </div>
        <div class="border-b border-gray-100 pt-6 ml-8 -mr-6"></div>
        <div class="w-full pt-6 flex xs:block items-center justify-between">
          <div class="inline-block"><address-icon></address-icon></div>
          <div class="text-sm inline-block pl-4 pr-4">
            {{ user_details ? user_details.address : '' }}
          </div>
          <div class="text-xxs float-right mt-1 text-nw-ash inline-block">Address</div>
        </div>
      </div>
    </div>
    <edit-profile v-if="edit_profile" :user_details="user_details" v-on:open-edit="openEdit"></edit-profile>
  </div>
</template>

<script>
import AddressIcon from '../components/icons/AddressIcon.vue'
import BackArrowIcon from '../components/icons/BackArrowIcon.vue'
// import CopyIcon from '../components/icons/CopyIcon.vue'
import EditIcon from '../components/icons/EditIcon.vue'
import EmailIcon from '../components/icons/EmailIcon.vue'
import PhoneIcon from '../components/icons/PhoneIcon.vue'
import ProfileIcon from '../components/icons/ProfileIcon.vue'
import EditProfile from '../components/Profile/EditProfile.vue'
export default {
  components: {
    BackArrowIcon,
    // CopyIcon,
    EditIcon,
    PhoneIcon,
    EmailIcon,
    AddressIcon,
    ProfileIcon,
    EditProfile
  },
  data() {
    return {
      edit_profile: false
    }
  },
  computed: {
    user_details() {
      return this.$store.state.user_details
    },
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    close() {
      this.$router.push({
        name: 'Dashboard'
      })
    },
    openEdit(val) {
      this.edit_profile = val
    }
  }
}
</script>
